/* @flow */
import BlockedUsers from 'collections/BlockedUsers';
import { ActionTypes } from 'constants/BlockedUserConstants';
import { dispatcher } from 'lib/Dispatcher';
import errorLogger from 'utils/errorLogger';

const BlockedUserActions = {
  load(): void {
    BlockedUsers.load()
      .then(blockedUsers => {
        dispatcher.dispatch({
          type: ActionTypes.LOAD_BLOCKED_USERS,
          blockedUsers,
        });
      })
      .catch(errorLogger('BlockedUsers load failed'));
  },
};

export default BlockedUserActions;
